"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireWildcard(require("../../../../../../../ui/Tooltip"));
var _helpers = require("./helpers");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var OperatorRateOfConfirmation = function OperatorRateOfConfirmation(_ref) {
  var rate = _ref.rate,
    className = _ref.className;
  var _getPropsByRate = (0, _helpers.getPropsByRate)(rate),
    icon = _getPropsByRate.icon,
    text = _getPropsByRate.text,
    description = _getPropsByRate.description;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: description,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.root, _styles.default[rate], className)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.icon,
    dangerouslySetInnerHTML: {
      __html: icon
    }
  }), text));
};
OperatorRateOfConfirmation.propTypes = {
  rate: _propTypes.default.string.isRequired,
  className: _propTypes.default.string
};
var _default = exports.default = (0, _react.memo)(OperatorRateOfConfirmation);